import { render, staticRenderFns } from "./RoadmapBaseEventCriteriaList.vue?vue&type=template&id=8c25c84c&"
import script from "./RoadmapBaseEventCriteriaList.vue?vue&type=script&lang=js&"
export * from "./RoadmapBaseEventCriteriaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports